import { render, staticRenderFns } from "./ImportSuccess.vue?vue&type=template&id=2052ff1b&scoped=true&"
import script from "./ImportSuccess.vue?vue&type=script&lang=ts&"
export * from "./ImportSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./ImportSuccess.vue?vue&type=style&index=0&id=2052ff1b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2052ff1b",
  null
  
)

export default component.exports